export const CHROME_PAGE_MATCHING_MAX_TEXT_LENGTH = 32000
export const CHROME_PAGE_MATCHING_MAX_HTML_LENGTH = 256000
export const CHROME_PAGE_MATCHING_RETENTION_DAYS = 30
export const CHROME_PAGE_MATCHING_UPLOAD_CONSENT_VERSION = 'v1'

export const CHROME_PAGE_MATCHING_OUTCOMES = [
  'task-list-incomplete',
  'not-a-page',
  'page-context-incomplete',
  'page-context-missing',
  'page-context-too-long',
  'multiple-page-units',
  'multiple-task-matches',
  'no-match',
  'unique-match',
  'request-failed',
] as const

export const CHROME_PAGE_MATCHING_MATCH_TYPES = ['resident-name', 'property-unit'] as const
export const CHROME_PAGE_MATCHING_SOURCES = ['escalation', 'leasingEscalation'] as const
export const CHROME_PAGE_MATCHING_TELEMETRY_STATUSES = [
  'saved',
  'unavailable',
  'not-consented',
] as const
